import { snakeStore } from '@app/plugins/vuex-async-pagginate';
import { CampaignsService } from '@autocaller_v2/services/CampaignsService';

export const table = snakeStore(
  {
    state: {
      mediafiles: []
    },
    mutations: {
      mediafiles: (state, value) => (state.mediafiles = value)
    },

    actions: {
      getData: (_, params) => CampaignsService.getList(params),
      setMediafiles({ commit }, value) {
        commit('mediafiles', value);
      }
    },

    getters: {
      mediafiles: (state) => state.mediafiles
    }
  },
  true
);
